/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 17/06/2025
 */
import Shepherd from "shepherd.js";
import 'shepherd.js/dist/css/shepherd.css';

export function helpPageTours() {
    // Check if the tour has been shown before for this path
    const shownTours = JSON.parse(localStorage.getItem('shown-help-page-tours')) || [];
    const currentPath = window.location.pathname;
    const firstPath = '/' + currentPath.split('/')[1];

    // If the tour has been shown before for this path, don't start it again
    if (shownTours.includes(firstPath)) {
        return null;
    }

    const tour = new Shepherd.Tour({
        useModalOverlay: true,
        defaultStepOptions: {
            classes: 'shadow-md bg-purple-dark dta-shepherd-class',
            scrollTo: false
        }
    });

    const addSkipButton = (buttons) => {
        buttons.unshift({
            text: 'Skip',
            action: tour.complete,
            classes: 'shepherd-button-secondary'
        });
        return buttons;
    };

    const fhCalendar = document.querySelector('.fh-departure-date');
    if (fhCalendar) {
        tour.addStep({
            id: 'fh-departure-date',
            text: 'You can choose your departure date by clicking on the green-colored dates. The list will appear directly below the calendar, and you can click on one of them to proceed with the booking process.',
            attachTo: {
                element: '.fh-departure-date',
                on: 'top-start'
            },
            buttons: addSkipButton([
                {
                    text: 'Next',
                    action: tour.next
                }
            ])
        });
    }

    if (document.querySelector('.departure-date')) {
        tour.addStep({
            id: 'departure-date',
            text: 'You can choose your departure date by clicking on the green dates. The price for your selected date will show up below.',
            attachTo: {
                element: '.departure-date',
                on: 'top-start'
            },
            buttons: addSkipButton([
                {
                    text: 'Next',
                    action: tour.next
                }
            ])
        });
    }

    if (document.querySelector('.price-list')) {
        if(document.querySelector('.price-list').children.length > 0) {
            tour.addStep({
                id: 'price-list',
                text: fhCalendar ? 'You can see the pricing details for each type here.' : 'You can see the pricing details for each type here. If the price suits you, just click the \'Book\' button. Alternatively, other pricing types are available below.',
                attachTo: {
                    element: document.querySelector('.price-list').children[0],
                    on: 'top-start'
                },
                buttons: addSkipButton([
                    {
                        text: 'Back',
                        action: tour.back
                    },
                    {
                        text: 'Next',
                        action: tour.next
                    }
                ])
            });
        }
    }

    if (document.querySelector('.left-price-list') || document.querySelector('.right-price-list')) {
        let attachElement = null;
        if(document.querySelector('.left-price-list').children.length > 0) {
            attachElement = document.querySelector('.left-price-list').querySelector('.price-header');
        } else if (document.querySelector('.right-price-list').children.length > 0) {
            attachElement = document.querySelector('.right-price-list').querySelector('.price-header');
        }

        if(attachElement) {
            tour.addStep({
                id: 'price-list',
                text: fhCalendar ? 'You can see the pricing details for each type here.' : 'You can see the pricing details for each type here. If the price suits you, just click the \'Book\' button. Alternatively, other pricing types are available below.',
                attachTo: {
                    element: attachElement,
                    on: 'top-start'
                },
                buttons: addSkipButton([
                    {
                        text: 'Back',
                        action: tour.back
                    },
                    {
                        text: 'Next',
                        action: tour.next
                    }
                ])
            });
        }
    }

    // Conditional steps for pickup-location, dropoff-location, and addon-list
    if (document.querySelector('.pickup-location')) {
        tour.addStep({
            id: 'pickup-location',
            text: fhCalendar ? 'Here\'s a list of pickup locations we offer.' : 'Here\'s a list of pickup locations we offer. You can choose your preferred one during the booking process.',
            attachTo: {
                element: '.pickup-location',
                on: 'top-start'
            },
            buttons: addSkipButton([
                {
                    text: 'Back',
                    action: tour.back
                },
                {
                    text: 'Next',
                    action: tour.next
                }
            ])
        });
    }

    if (document.querySelector('.dropoff-location')) {
        tour.addStep({
            id: 'dropoff-location',
            text: fhCalendar ? 'Here\'s a list of drop-off locations we offer.' : 'Here\'s a list of drop-off locations we offer. You can choose your preferred one during the booking process.',
            attachTo: {
                element: '.dropoff-location',
                on: 'top-start'
            },
            buttons: addSkipButton([
                {
                    text: 'Back',
                    action: tour.back
                },
                {
                    text: 'Next',
                    action: tour.next
                }
            ])
        });
    }

    if (document.querySelector('.addon-list')) {
        if(document.querySelector('.addon-list').children.length > 0) {
            const addonList = document.querySelector('.addon-list');
            const firstAddonItem = addonList.querySelector('.card, .accordion_2');
            if(firstAddonItem) {
                tour.addStep({
                    id: 'addon-list',
                    text: fhCalendar ? 'Here, you can find and select additional services or features to make your activities more complete and enjoyable.' : 'Here, you can find and select additional services or features to make your activities more complete and enjoyable. You can choose them during the booking process.',
                    attachTo: {
                        element: firstAddonItem,
                        on: 'top-start'
                    },
                    buttons: addSkipButton([
                        {
                            text: 'Back',
                            action: tour.back
                        },
                        {
                            text: 'Next',
                            action: tour.next
                        }
                    ])
                });
            }
        }
    }

    if (document.querySelector('.enquire-now')) {
        tour.addStep({
            id: 'enquire-now',
            text: 'For any additional questions, feel free to fill out this form to ask about the tour. Our team will respond to your inquiry promptly.',
            attachTo: {
                element: '.enquire-now',
                on: 'top-start'
            },
            buttons: [
                {
                    text: 'Back',
                    action: tour.back
                },
                {
                    text: 'Finish',
                    action: tour.complete,
                    classes: 'shepherd-button-secondary'
                }
            ]
        });
    }

    tour.on('show', event => {
        setTimeout(() => {
            const header = window.document.querySelector('header');
            const stickyHorizontal = window.document.querySelector('.sticky_horizontal');
            const rect = event.step.target.getBoundingClientRect();
            const stepHeight = event.step.el.offsetHeight;
            const stickyHeight = stickyHorizontal ? stickyHorizontal.offsetHeight : 0;
            const posY = currentScrollPosition + rect.top - (header.offsetHeight + stickyHeight + stepHeight + 16);

            window.scrollTo({
                top: posY,
                behavior: 'smooth'
            });
        }, 0);
    });

    // Mark the tour as shown when it's completed
    tour.on('complete', () => {
        saveToursShownStatus();
    });

    // Also mark the tour as shown if it's cancelled
    tour.on('cancel', () => {
        saveToursShownStatus();
    });

    function saveToursShownStatus() {
        const currentPath = window.location.pathname;
        const firstPath = '/' + currentPath.split('/')[1]; // Get the first path segment

        // Get the existing array from localStorage or initialize a new one
        let shownTours = JSON.parse(localStorage.getItem('shown-help-page-tours')) || [];

        // Check if the first path is already in the array
        if (!shownTours.includes(firstPath)) {
            shownTours.push(firstPath);
            localStorage.setItem('shown-help-page-tours', JSON.stringify(shownTours));
        }
    }

    return tour;
}
